var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_32_01326"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23,
    height: 12,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    },
    clipPath: "url(#master_svg0_32_01326)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "passthrough"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1307,0L10.1307,12L7.63636,12L7.63636,6.90909L2.49432,6.90909L2.49432,12L0,12L0,0L2.49432,0L2.49432,4.78409L7.63636,4.78409L7.63636,0L10.1307,0ZM16.5682,0Q18.4602,0,19.8977,0.738636Q21.3409,1.47727,22.125,2.84659Q22.9091,4.21023,22.9091,6.01705Q22.9091,7.81818,22.125,9.17045Q21.3409,10.5227,19.8977,11.2614Q18.4602,12,16.5682,12L12.3636,12L12.3636,0L16.5682,0ZM16.5284,9.875Q18.3864,9.875,19.3977,8.86932Q20.4148,7.85795,20.4148,6.02273Q20.4148,4.19318,19.3977,3.15909Q18.3864,2.125,16.5284,2.125L14.858,2.125L14.858,9.875L16.5284,9.875Z",
    fillOpacity: 0.8999999761581421
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHd);
export default __webpack_public_path__ + "static/media/HD.46a3f347.svg";
export { ForwardRef as ReactComponent };